module.exports = __webpack_public_path__ + "static/img/A (3).eff5d16c.png";